module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_1@3x.49e5668f.png";